import React, { useEffect, useState } from 'react';
import { Banner, BlockStack, Checkbox } from '@shopify/polaris';
import RentalStatusPill from './RentalStatusPill';
import { rentalsAPI } from '../services/api';
import { fulfillmentOptions, fulfillmentValue } from '../utils/rentalStatus';

export default function RentalFulfillmentControl({ rental, onUpdated }) {
  const [current, setCurrent] = useState(rental);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notifyCustomer, setNotifyCustomer] = useState(false);
  useEffect(() => { setCurrent(rental); setError(''); setNotifyCustomer(false); }, [rental]);
  const value = fulfillmentValue(current);

  const update = async (fulfillmentStatus) => {
    setSaving(true);
    setError('');
    try {
      const { data } = await rentalsAPI.updateStatus(current.id, {
        fulfillmentStatus: fulfillmentStatus || null,
        notifyCustomer: fulfillmentStatus === 'fulfilled' && notifyCustomer,
      });
      setCurrent(data);
      setNotifyCustomer(false);
      onUpdated?.(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update fulfillment status');
    } finally {
      setSaving(false);
    }
  };

  return (
    <BlockStack gap="200">
      {error && <Banner tone="critical" onDismiss={() => setError('')}>{error}</Banner>}
      <RentalStatusPill
        label={fulfillmentOptions.find((option) => option.value === value)?.label || 'Not started'}
        editLabel={`Edit fulfillment status for rental #${current.id}`}
        options={fulfillmentOptions.map((option) => ({
          ...option,
          disabled: (!option.value && value !== 'packing_in_progress') ||
            (['fulfilled', 'return_received', 'checked_done'].includes(value) && ['packing_in_progress', 'packed'].includes(option.value)) ||
            (['return_received', 'checked_done'].includes(value) && option.value === 'fulfilled') ||
            (option.value === 'return_received' && !['fulfilled', 'return_received'].includes(value)) ||
            (option.value === 'checked_done' && !['return_received', 'checked_done'].includes(value)),
        }))}
        value={value}
        onChange={update}
        loading={saving}
        disabled={['draft', 'cancelled'].includes(current.status)}
      >
        {!['fulfilled', 'return_received', 'checked_done'].includes(value) && (
          <Checkbox label="Send Shopify shipping notification when fulfilling" checked={notifyCustomer} onChange={setNotifyCustomer} disabled={saving} />
        )}
      </RentalStatusPill>
    </BlockStack>
  );
}
